// export this package's api
import Align from './Align';

export default Align;


//////////////////
// WEBPACK FOOTER
// ./~/rc-align/es/index.js
// module id = 649
// module chunks = 2